import React from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import styled from 'styled-components'
import { FormGroup } from 'reactstrap'
import ErrorMessage from './ErrorMessage'
import LabelCustom from './LabelCustom'
import InputCustom from './InputCustom'

const StyledSelect = styled(InputCustom)`
  background: url(https://cdn0.iconfinder.com/data/icons/slim-square-icons-basics/100/basics-08-512.png)
    no-repeat right white;
  -webkit-appearance: none;
  background-size: 28px;
  background-position: calc(100% - 6px) 6px;
`

export default function Select({ name }) {
  const [
    { label, placeholder, validate, options },
    error,
  ] = useStoreState(state => [
    state.form.getByName(name),
    state.form.getErrorByName(name),
  ])
  const [setInputValue] = useStoreActions(actions => [
    actions.form.setInputValue,
  ])
  return (
    <FormGroup className="col-xs-12">
      <LabelCustom htmlFor={`select-${name}`}>
        {label} {validate && validate.presence && <>*</>}
      </LabelCustom>
      <StyledSelect
        type="select"
        name={name}
        id={`select-${name}`}
        defaultValue=""
        onChange={({ target: { value } }) => {
          setInputValue({ name, value })
        }}
      >
        <option disabled value="">
          {placeholder}
        </option>
        {options.map(option => (
          <option key={`option-${option}`}>{option}</option>
        ))}
      </StyledSelect>
      <ErrorMessage error={error} id={`error-${name}`} />
    </FormGroup>
  )
}
